<script>
  import ChevronRight from "lucide-svelte/icons/chevron-right";
  import {buttonVariants} from "$lib/components/ui/button/index.js";
  import {cn} from "$lib/utils.js";
  import NextButton from "./bits/calendar-next-button.svelte";

  let {ref = $bindable(null), class: className, children, ...restProps} = $props();
</script>

{#snippet Fallback()}
  <ChevronRight class="size-4"/>
{/snippet}

<NextButton
  bind:ref
  class={cn(
		buttonVariants({ variant: "outline" }),
		"size-7 bg-transparent p-0 opacity-50 hover:opacity-100",
		className
	)}
  children={children || Fallback}
  {...restProps}
/>
